import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Убедитесь, что там есть глобальные стили
import "./config/axiosSetup"; // Устанавливает патч fetch и перехватчик axios (ротация refresh-токена)
import App from "./App";
import store from "./redux/redux-store";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
    </React.StrictMode>
);
